module.exports = __webpack_public_path__ + "./Welsen_f4e49cc2ff5c38be7e50c6369ba7c79a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2020/Welsen.jpg
// module id = 510
// module chunks = 0